export const generateCommentCIDKey = ({
  orgId,
  streamId,
  channelId,
  streamItemId,
  commentId,
}) => [orgId, streamId, channelId, streamItemId, commentId].join('/');
